export const preparePostPreview = postContent =>
  postContent
    .filter(item => item.type === 'paragraph')
    .map(item => (item.children[0].text ? item.children[0].text + '\n' : '\n'))
    .join('')
    .trim();
